<div class="signup-wrapper flex flex-column overflow-auto" *ngIf="!isLoading">
  <div class="text-xl flex m-2">
    <img style="height: 85px" src="assets/img/logo-cefla.png" alt="" />
  </div>

  <div class="mb-4 text-4xl font-semibold text-geometric-precision">{{ 'PAGES.SIGNUP.TITLE' | translate }}</div>

  <div class="flex w-full md:w-9 justify-content-start">
    <button
      pButton
      class="p-button-secondary p-button-text mb-2"
      icon="fa fa-arrow-left"
      [label]="'BUTTONS.GO_BACK' | translate"
      (click)="goBack()"
    ></button>
  </div>

  <div class="flex flex-column px-5 py-5 mb-6 surface-card border-round-xl w-12 md:w-9">
    <div class="mb-1 text-3xl font-semibold text-geometric-precision" innerHTML="{{ 'PAGES.SIGNUP.REGISTRATION_WELCOME_TITLE' | translate }}"></div>
    <div class="mb-4 text-color-secondary text-geometric-precision" innerHTML="{{ 'PAGES.SIGNUP.REGISTRATION_WELCOME_MESSAGE' | translate }}"></div>

    <form [formGroup]="signupForm">
      <div class="mb-4">
        <div class="mb-3 text-2xl font-semibold text-geometric-precision">{{ 'PAGES.SIGNUP.LOCATION_INFO' | translate }}</div>

        <div class="grid mb-2">
          <div [ngClass]="!countryStates.length ? 'md:col-6 col-12' : 'md:col-2 col-12'">
            <app-language-selector
              [languages]="languages"
              [isRequired]="true"
              [onlyFlag]="false"
              formControlName="language"
              (ngModelChange)="onLanguageChange($event)"
            ></app-language-selector>
            <small *ngIf="signupFormErr['language']" id="language-help" class="p-error block mt-1">
              {{ signupFormErr['language'] | translate }}
            </small>
          </div>

          <div [ngClass]="!countryStates.length ? 'md:col-6 col-12' : 'md:col-5 col-12'">
            <app-country-selector [countries]="countries" [isRequired]="true" formControlName="country"></app-country-selector>
            <small *ngIf="signupFormErr['country']" id="country-help" class="p-error block mt-1">
              {{ signupFormErr['country'] | translate }}
            </small>
          </div>

          <div class="md:col-5 col-12" *ngIf="countryStates.length">
            <label for="stateDropdown" class="block mb-1 text-color-secondary" [iosRequired]="true">{{ 'LABEL.STATE' | translate }}</label>
            <p-dropdown
              id="stateDropdown"
              [options]="countryStates"
              formControlName="state"
              class="ios-selector-large"
              styleClass="w-full"
              appendTo="body"
              placeholder="{{ 'LABEL.SELECT_STATE' | translate }}"
              optionDisabled="disabled"
              [autoDisplayFirst]="false"
              optionValue="stateId"
              optionLabel="name"
            >
            </p-dropdown>
            <small *ngIf="signupFormErr['state']" id="state-code-help" class="p-error block mt-1">
              {{ signupFormErr['state'] | translate }}
            </small>
          </div>
        </div>

        <div class="grid">
          <div class="md:col-4 col-12">
            <label for="address" [iosRequired]="true" class="block mb-1 text-color-secondary"> {{ 'LABEL.ADDRESS' | translate }} </label>
            <input class="w-full pt-3 pl-3 pb-3" id="address" formControlName="address" type="text" pInputText />
            <small *ngIf="signupFormErr['address']" id="address-help" class="p-error block mt-1">
              {{ signupFormErr['address'] | translate }}
            </small>
          </div>

          <div class="md:col-4 col-12">
            <label for="zipCode" [iosRequired]="true" class="block mb-1 text-color-secondary"> {{ 'LABEL.ZIP_CODE' | translate }} </label>
            <input class="w-full pt-3 pl-3 pb-3" id="zipCode" formControlName="zipCode" type="text" pInputText />
            <small *ngIf="signupFormErr['zipCode']" id="zip-code-help" class="p-error block mt-1">
              {{ signupFormErr['zipCode'] | translate }}
            </small>
          </div>

          <div class="md:col-4 col-12">
            <label for="city" [iosRequired]="true" class="block mb-1 text-color-secondary"> {{ 'LABEL.CITY' | translate }} </label>
            <input class="w-full pt-3 pl-3 pb-3" id="city" formControlName="city" type="text" pInputText />
            <small *ngIf="signupFormErr['city']" id="city-help" class="p-error block mt-1">
              {{ signupFormErr['city'] | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <div class="mb-3 text-2xl font-semibold text-geometric-precision">{{ 'PAGES.SIGNUP.PERSONAL_INFO' | translate }}</div>

        <div class="grid mb-2">
          <div class="md:col-6 col-12">
            <label for="organization" [iosRequired]="true" class="block mb-1 text-color-secondary"> {{ 'LABEL.BUSINESS_NAME' | translate }} </label>
            <input class="w-full pt-3 pl-3 pb-3" id="organization" formControlName="organization" type="text" pInputText />
            <small *ngIf="signupFormErr['organization']" id="organization-help" class="p-error block mt-1">
              {{ signupFormErr['organization'] | translate }}
            </small>
          </div>

          <div class="md:col-6 col-12">
            <label for="vatNumber" [iosRequired]="isVatNumberRequired" class="block mb-1 text-color-secondary">
              {{ 'LABEL.VAT_NUMBER' | translate }}
            </label>
            <input class="w-full pt-3 pl-3 pb-3" id="vatNumber" formControlName="vatNumber" type="text" maxlength="11" pInputText />
            <small *ngIf="signupFormErr['vatNumber']" id="vat-number-help" class="p-error block mt-1">
              {{ signupFormErr['vatNumber'] | translate }}
            </small>
          </div>
        </div>

        <div class="grid mb-2">
          <div class="md:col-6 col-12">
            <label for="firstName" [iosRequired]="true" class="block mb-1 text-color-secondary"> {{ 'LABEL.FIRST_NAME' | translate }} </label>
            <input class="w-full pt-3 pl-3 pb-3" id="firstName" formControlName="firstName" type="text" pInputText />
            <small *ngIf="signupFormErr['firstName']" id="firstName-help" class="p-error block mt-1">
              {{ signupFormErr['firstName'] | translate }}
            </small>
          </div>

          <div class="md:col-6 col-12">
            <label for="lastName" [iosRequired]="true" class="block mb-1 text-color-secondary"> {{ 'LABEL.LAST_NAME' | translate }} </label>
            <input class="w-full pt-3 pl-3 pb-3" id="lastName" formControlName="lastName" type="text" pInputText />
            <small *ngIf="signupFormErr['lastName']" id="lastName-help" class="p-error block mt-1">
              {{ signupFormErr['lastName'] | translate }}
            </small>
          </div>
        </div>

        <div class="grid mb-2">
          <div class="md:col-6 col-12">
            <app-phone-number-input [isRequired]="true" [phonePrefixes]="phonePrefixes" formControlName="phone"></app-phone-number-input>
            <small *ngIf="signupFormErr['phone']" id="phone-help" class="p-error block mt-1">
              {{ signupFormErr['phone'] | translate }}
            </small>
          </div>

          <div class="md:col-6 col-12">
            <label for="email" [iosRequired]="true" class="block mb-1 text-color-secondary"> {{ 'LABEL.EMAIL' | translate }} </label>
            <input class="w-full pt-3 pl-3 pb-3" id="email" formControlName="email" type="text" pInputText />
            <small *ngIf="signupFormErr['email']" id="email-help" class="p-error block mt-1">
              {{ signupFormErr['email'] | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <div class="mb-3 text-2xl font-semibold text-geometric-precision">{{ 'PAGES.SIGNUP.LOGIN_INFO' | translate }}</div>

        <div class="grid mb-2">
          <div class="flex flex-column md:col-6 col-12">
            <app-password-input [isRequired]="true" formControlName="password" [type]="'password'"></app-password-input>
            <small *ngIf="signupFormErr['password']" id="password-help" class="p-error block mt-1">
              {{ signupFormErr['password'] | translate }}
            </small>
          </div>

          <div class="flex flex-column md:col-6 col-12">
            <app-password-input [isRequired]="true" formControlName="confirmPassword" [type]="'confirmPassword'"></app-password-input>
            <small *ngIf="signupFormErr['confirmPassword']" id="confirmPassword-help" class="p-error block mt-1">
              {{ signupFormErr['confirmPassword'] | translate }}
            </small>
          </div>
        </div>
      </div>
    </form>

    <div class="mb-3 text-2xl font-semibold text-geometric-precision">{{ 'LABEL.PRIVACY_POLICY' | translate }}</div>
    <app-fixed-text-area [value]="'PAGES.SIGNUP.PRIVACY_POLICY_DESC' | translate" [rows]="10" (scrolledEnded)="scrollEnded('PRIVACY_POLICY')">
    </app-fixed-text-area>

    <div class="flex gap-2 align-items-center mt-3">
      <p-checkbox [(ngModel)]="privacyPolicyAccepted" [binary]="true" [disabled]="privacyPolicyDisabled"></p-checkbox>
      <label for="termsAccepted" class="block text-color-secondary"> {{ 'PAGES.SIGNUP.ACCEPT_PRIVACY_POLICY' | translate }} </label>
    </div>

    <div class="mt-6 mb-3 text-2xl font-semibold text-geometric-precision">{{ 'LABEL.LICENSE_AGREEMENT' | translate }}</div>
    <app-fixed-text-area [value]="'PAGES.SIGNUP.LICENSE_AGREEMENT_DESC' | translate" (scrolledEnded)="scrollEnded('LICENSE_CONTRACT')">
    </app-fixed-text-area>

    <div class="flex gap-2 align-items-center mt-3">
      <p-checkbox [(ngModel)]="termsAndConditionsAccepted" [binary]="true" [disabled]="licenseContractDisabled"></p-checkbox>
      <label for="termsAccepted" class="block text-color-secondary"> {{ 'PAGES.SIGNUP.ACCEPT_TERMS' | translate }} </label>
    </div>

    <div class="button-wrapper gap-2">
      <button
        class="h-4rem w-12rem"
        pButton
        type="button"
        label="{{ 'BUTTONS.CONFIRM' | translate }}"
        [disabled]="isSaving || !termsAndConditionsAccepted || !privacyPolicyAccepted"
        iconPos="right"
        [loading]="isSaving"
        (click)="doSignup()"
      ></button>
    </div>
  </div>
</div>

<div class="h-full flex justify-content-center align-items-center" *ngIf="isLoading">
  <p-progressSpinner></p-progressSpinner>
</div>
